// extracted by mini-css-extract-plugin
module.exports = {"manageBox":"index_manageBox_j4fev","title":"index_title_2aRpz","manageContent":"index_manageContent_3ZPIk"};